
























































































import { Component, Vue, Watch } from "vue-property-decorator"
import downloadDialog, { downloadDialogType } from "@/components/downloadDialog"
import shareDialog from "@/components/shareDialog"
import updateTdk, { formatTDK } from "@/utils/tdk"
import { timeago } from "@/utils/base"
import { IBreadcrumbItem } from "@/components/breadcrumb/extra"

@Component({
  name: "Article",
  components: {
    Content: () => import("@/views/CommunityArticle/components/content.vue"),
    Comment: () => import("./components/comment.vue"),
    GameInfo: () => import("./components/gameInfo.vue"),
    ScanDownload: () => import("@/components/scanDownload/scanDownload.vue"),
    HotContent: () => import("@/views/BbsList/components/HotContent.vue"),
    Breadcrumb: () => import("@/components/breadcrumb/breadcrumb.vue")
  },
  tdk() {
    return this.$store.state.tdk
  }
})
export default class Article extends Vue {
  breads: IBreadcrumbItem[] = []

  publishTime = ""

  get detail() {
    const TIME = this.$store.state.article.detail?.time
    this.publishTime = TIME && timeago(TIME * 1000)
    return this.$store.state.article.detail
  }

  get hideOthers() {
    return this.detail && this.detail.type && this.detail.type === "隐私政策"
  }

  // ssr hook
  serverPrefetch() {
    return this.fetchData()
  }

  beforeMount() {
    if (!this.detail) {
      this.fetchData()
    } else {
      this.formatData()
    }
  }

  fetchData() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.$root.$tstore.modules.article.actions.FETCH_DETAIL({
          article_id: this.$route.params.article_id
        })

        this.formatData()

        if (this.detail.type && this.detail.type === "seo精选内容") {
          await this.$store.dispatch("tdk/FETCH_SUB_TDK", {
            type: "game",
            _id_or_name: this.detail._id,
            sub_type: "seo_article"
          })
        } else {
          await this.$store.dispatch("tdk/FETCH_SUB_TDK", {
            type: "game",
            _id_or_name: this.detail._id,
            sub_type: "article"
          })
        }

        this.$store.commit(
          "tdk/SET_TDK",
          formatTDK(this.$store.state.tdk, [
            {
              replaceKey: "{游戏名称}",
              replaceVal: this.detail.game.name
            },
            {
              replaceKey: "{文章标题}",
              replaceVal: this.detail.title
            },
            {
              replaceKey: "{文章正文内容}",
              replaceVal: this.detail.content
                .replace(/<\/?.+?\/?>/g, "")
                .replace(/\n/g, "")
                .replace(/&nbsp/g, "")
                .substr(0, 50)
            },
            {
              replaceKey: "{文章内容}",
              replaceVal: this.detail.content
                .replace(/<\/?.+?\/?>/g, "")
                .replace(/\n/g, "")
                .replace(/&nbsp/g, "")
                .substr(0, 50)
            },
            {
              replaceKey: "{文章简介}",
              replaceVal: this.detail.excerpt
            },
            {
              replaceKey: "{关键词}",
              replaceVal: this.detail.seo_keyword || ""
            }
          ])
        )

        updateTdk.call(this)

        resolve("")
      } catch (error) {
        reject(error)
        if (!this.$isServer) {
          this.$router.push("/404")
        }
      }
    })
  }

  formatData() {
    this.detail.content = this.detail.content.replace(
      /https:\/\/resource.ghzs.com\/image\/community\/5b694f242924bcf82441b3fc\.png/g,
      "http://static-web.ghzs.com/website-static/images/icon_article.png"
    )
    this.detail.content = this.detail.content.replace(
      /https:\/\/resource.ghzs.com\/image\/community\/575fa87d8ab49e12658b4cds\.png/g,
      "http://static-web.ghzs.com/website-static/images/icon_reply.png"
    )
    this.detail.content = this.detail.content.replace(
      /ghzhushou:\/\/[^("|')]*/g,
      match => {
        return `javascript:void(0); redirect('${match}')`
      }
    )

    //breads
    this.breads = [
      { name: "首页", path: "/" },
      {
        name: this.detail.game.name,
        path: `/${this.detail.game._seq}`
      },
      { name: this.detail.title }
    ]
  }

  destroyed() {
    this.$store.commit("article/SET_DETAIL", { detail: null })
  }

  handleShare() {
    // shareDialog(
    //   {
    //     rmAfterDestroy: false,
    //     presetData: {}
    //   },
    //   () => {}
    // )
    downloadDialog(
      {
        rmAfterDestroy: false,
        presetData: {
          type: downloadDialogType.BBS
        }
      },
      () => {}
    )
  }

  handleDownload() {
    downloadDialog(
      {
        rmAfterDestroy: false,
        presetData: {
          type: downloadDialogType.BBS
        }
      },
      () => {}
    )
  }

  // 监听路由变化，有变化则重新加载数据
  @Watch("$route")
  routerUpdate(to) {
    this.$store.commit("article/SET_DETAIL", { detail: null })
    this.fetchData()
  }
}
